export const resolveImgPath = (iconAssetsPath, img) => `${iconAssetsPath}/${img}.svg`;
//# sourceMappingURL=helpers.js.map
